import "./BecomeABuyer.module.css";
import Header from "@/reusable_sections/Header";
import Benefits from "./sections/Benefits";
import Process from "./sections/Process";
import TradingWorkflow from "./sections/TradingWorkflow";
import Buyerfaq from "./sections/Buyerfaq";
import BuyerRegistration from "./sections/BuyerRegistration";
import Inventory from "./sections/Inventory";
import BuyerJourney from "./sections/BuyerJourney";
import BuyerRegistrationForm from "./sections/BuyerRegistrationForm";
import Faq from "./sections/Faq";
import Buyerregistrationform from "./sections/Buyerregistrationform";
import Footer from "@/reusable_sections/Footer";
export default function BecomeABuyerPage() {
  return <div>
      <Header />
      <Benefits />
      <Process />
      <TradingWorkflow />
      <Buyerfaq />
      <BuyerRegistration />
      <Inventory />
      <BuyerJourney />
      <BuyerRegistrationForm />
      <Faq />
      <Buyerregistrationform />
      <Footer />
    </div>;
}